import React from 'react';
import { Box, Typography, CircularProgress, styled } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

export type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

const SaveStatusContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'end',
}));

interface SaveStatusIndicatorProps {
    status: SaveStatus;
}

const SaveStatusIndicator: React.FC<SaveStatusIndicatorProps> = ({ status }) => {       
    return (
        <SaveStatusContainer>
            {status === 'saving' && (
                <>
                    <CircularProgress size={20} sx={{ marginRight: 1 }} />
                    <Typography variant="caption">Salvando...</Typography>
                </>
            )}
            {(status === 'saved' || status === 'idle') && (
                <>
                    <CheckCircleIcon sx={{ color: 'green', marginRight: 1 }} fontSize="small" />
                    <Typography variant="caption">Salvo</Typography>
                </>
            )}
            {status === 'error' && (
                <>
                    <ErrorIcon sx={{ color: 'red', marginRight: 1 }} fontSize="small" />
                    <Typography variant="caption">Erro ao salvar</Typography>
                </>
            )}
        </SaveStatusContainer>
    );
};

export default SaveStatusIndicator;
